import { doc, deleteDoc } from "firebase/firestore";
import { db } from "../../Firebase";

export default async function deleteProduct(id) {
  await deleteDoc(doc(db, "products", id));
}
